// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { BarChartCard } from '@/components/bar-chart-card';
import { LocationOwnershipReport } from '@/location/api/get-location-report';
import {
  LocationReportSort,
  useLocationReport,
} from '@/location/hooks/use-location-report';
import { getEffectiveLocationName } from '@/location/utilities/get-effective-third-party';
import { colors } from '@mui/material';

const SOLD_COLOR = '#d2b48c';
const OWNED_COLOR = colors.teal[500];

type Key = Extract<keyof LocationOwnershipReport, 'ownedCount' | 'soldCount'>;

const KEYS: Key[] = ['ownedCount', 'soldCount'];

function getLabelForKey(key: Key) {
  switch (key) {
    case 'ownedCount':
      return 'Owned';

    case 'soldCount':
      return 'Sold';
  }
}

interface Props {
  sort: LocationReportSort;
}

export function LocationOwnershipReportCard(props: Props) {
  const { ownershipData, isLoading } = useLocationReport(props.sort);

  const colors = [OWNED_COLOR, SOLD_COLOR];
  const emptyState = isLoading
    ? 'Loading'
    : 'There is no location data to display';

  return (
    <BarChartCard
      title="Asset ownership at location"
      emptyState={emptyState}
      keys={KEYS}
      data={ownershipData}
      colors={colors}
      getLabelForKey={getLabelForKey}
      getLabelForDatum={(datum) => getEffectiveLocationName(datum.location)}
      pluralizeTooltipOptions={{ singular: 'asset' }}
    />
  );
}
